/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h1: "h1",
      p: "p",
      a: "a",
      h3: "h3",
      ul: "ul",
      li: "li",
      strong: "strong"
    }, props.components), {Q} = _components;
    if (!Q) _missingMdxReference("Q", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h1, {
        children: "Dražební portál Art Investment Gallery"
      }), "\n", _jsx(Q, {
        title: "Co je AIG?",
        children: _jsx(_components.p, {
          children: "Art Investment Gallery je mezinárodní online dražební portál se sídlem v České republice a s pobočkami v několika zemích Evropy, kde můžete dražit hodnotná a kvalitní umělecká díla z pohodlí Vašeho domova v prostředí nejpokročilejšího online dražebního portálu nejen na českém trhu."
        })
      }), "\n", _jsxs(Q, {
        title: "Jak dražby na AIG fungují?",
        children: [_jsx(_components.p, {
          children: "Aukční položky jsou vždy uveřejněny v samostatných aukčních blocích po dobu minimálně jednoho měsíce. Jsou seřazeny za sebou s časovým rozestupem odvíjejícím se od celkového počtu položek v aukčním bloku, vždy však minimálně s rozestupem 1 minuty."
        }), _jsx(_components.p, {
          children: "Uživatelé tak mohou realizovat příhozy od samotného uveřejnění aukčního bloku. Konce jednotlivých aukčních položek jsou naplánovány v rozmezí jednoho až dvou dní ve specifických časových intervalech."
        }), _jsx(_components.p, {
          children: "V případě provedení příhozu v posledních 3 minutách draženého díla, se časomíra opět resetuje na další 3 minuty."
        })]
      }), "\n", _jsxs(Q, {
        title: "Jak fungují příhozy?",
        children: [_jsxs(_components.p, {
          children: ["Uživatel má možnost přihodit standardním nebo limitním příhozem. Všechny standardní a limitní příhozy jsou realizované v EUR a uživatel si může nastavit svou lokální měnu v ", _jsx(_components.a, {
            href: "/my/settings",
            children: "nastavení účtu"
          }), " pro orientační přepočet v průběhu dražby."]
        }), _jsx(_components.p, {
          children: "Při platbě vydraženého díla si uživatel může zvolit v jaké měně (USD, EUR, CZK) bude faktura vystavena."
        }), _jsx(_components.h3, {
          children: "Standardní příhoz"
        }), _jsxs(_components.p, {
          children: ["Pokud jste v aukci prvním dražitelem, může být Váš prvotní příhoz roven vyvolávací ceně. V případě příhozu Vám systém předvyplní minimální výši příhozu. Ta se odvíjí od aktuální ceny díla dle tabulky minimálních příhozů. Výši Vašeho příhozu si můžete libovolně upravit, musíte však splnit podmínku minimálního příhozu. Po potvrzení příhozu, se cena díla zvýší na Vaši maximální nabídku, kterou uvidíte v historii příhozů daného díla a rovněž zjistíte, jestli je právě Váš příhoz v současné chvíli tím nejvyšším. Všechna díla, na která přihazujete, můžete přehledně sledovat ve svém uživatelském účtu v sekci ", _jsx(_components.a, {
            href: "/my/auctions",
            children: "probíhající aukce"
          }), ". V případě překonání Vašeho příhozu, budete informováni prostřednictvím e-mailu a notifikace na webové stránce daného díla."]
        }), _jsx(_components.h3, {
          children: "Limitní příhoz"
        }), _jsx(_components.p, {
          children: "V případě nastavení limitního příhozu zadáváte maximální částku, kterou jste ochotni za dané dílo nabídnout. Systém poté za Vás automaticky přihazuje nejnižší možné příhozy, aby zajistil Vaše prvenství v aukci daného díla. V případě překonání Vašeho limitu jiným účastníkem dražby, budete upozorněni na Vámi zadaný e-mail, který jste uvedli při registraci."
        }), _jsx(_components.p, {
          children: "Všechny limitní příhozy jsou v historii příhozu označeny symbolem kladívka."
        }), _jsx(_components.p, {
          children: "V případě souběhu dvou stejně nastavených limitních příhozů, systém upřednostní příhoz uživatele, jenž svůj limitní příhoz nastavil jako první."
        })]
      }), "\n", _jsxs(Q, {
        title: "Jak se mohu účastnit dražby?",
        children: [_jsx(_components.p, {
          children: "Pro účast v dražbě si musí uživatel vytvořit svůj „uživatelský účet“, který musí aktivovat a následně ověřit."
        }), _jsx(_components.p, {
          children: "Po zadání všech povinných údajů obdržíte na Vámi zadanou e-mailovu adresu e-mail s ověřovacím odkazem. Po ověření e-mailu, se Vám aktivuje účet pro přihlášení do portálu AIG. Po aktivaci účtu má uživatel možnost procházet všechny položky nabízené v aukci spolu s historií příhozů a výsledků z minulých aukcí."
        }), _jsx(_components.p, {
          children: "Pro možnost přihazování v aktuální aukci si musí uživatel ověřit svůj účet v uživatelské sekci na základě průkazu totožnosti (občanský průkaz, cestovní pas) prostřednictvím ověřovací služby „Veriff“."
        })]
      }), "\n", _jsxs(Q, {
        title: "Jak zjistím, zda je můj účet ověřený a připravený k účasti v dražbě?",
        children: [_jsxs(_components.p, {
          children: ["V detailu uživatelského účtu pod záložkou ", _jsx(_components.a, {
            href: "/my/account#verification",
            children: "uživatelské údaje najdete sekci ověření profilu"
          }), ", kde zjistíte aktuální stav ověření Vašeho účtu."]
        }), _jsxs(_components.p, {
          children: ["Pokud by došlo při zpracování dokumentů z Vaší strany k delšímu prodlení, kontaktujte nás prosím na e-mail ", _jsx(_components.a, {
            href: "mailto:podpora@artinvestmentgallery.com",
            children: "podpora@artinvestmentgallery.com"
          }), "."]
        })]
      }), "\n", _jsxs(Q, {
        title: "Jsem přihlášený, ale nemůžu přihazovat.",
        children: [_jsx(_components.p, {
          children: "V případě, že jste přihlášený, ale nemůžete provést příhoz, zkontrolujte si, zda máte ověřený účet podle průkazu totožnosti."
        }), _jsxs(_components.p, {
          children: ["Ověření totožnosti provedete pomocí ověřovací služby „Veriff“, kterou najdete v nastavení svého účtu pod záložkou ", _jsx(_components.a, {
            href: "/my/account",
            children: "uživatelské údaje – ověření profilu"
          }), "."]
        }), _jsx(_components.p, {
          children: "Zde můžete taky sledovat stav a průběh Vašeho ověření."
        }), _jsxs(_components.p, {
          children: ["V případě, že je Váš profil ověřen, ale stále nejste schopen provést příhoz, napište nám prosím na ", _jsx(_components.a, {
            href: "mailto:podpora@artinvestmentgallery.com",
            children: "podpora@artinvestmentgallery.com"
          }), "."]
        })]
      }), "\n", _jsxs(Q, {
        title: "Proč se zadávají příhozy pouze v EUR?",
        children: [_jsx(_components.p, {
          children: "Jelikož má AIG narozdíl od ostatních českých aukcí mezinárodní klientelu, rozhodli jsme se pro dražbu v jednotné měně EUR, a to z důvodů předejít možným komplikacím při přepočtů měn a rozdílných výší minimálních příhozů."
        }), _jsx(_components.p, {
          children: "V nastavení uživatelského účtu si však můžete nastavit svou výchozí měnu (EUR, USD, CZK) a systém Vám tak bude zobrazovat orientační přepočet ve Vámi zvolené měně podle aktuálního kurzu."
        })]
      }), "\n", _jsx(Q, {
        title: "Proč dražba konkrétní položky neskončí přesně ve stanoveném čase?",
        children: _jsx(_components.p, {
          children: "V případě, že uživatel provede příhoz v posledních třech minutách, systém automaticky resetuje časomíru na 00:03:00, aby získali ostatní uživatelé možnost realizovat další příhoz."
        })
      }), "\n", _jsxs(Q, {
        title: "Jak mohu upravit svůj limit limitního příhozu?",
        children: [_jsx(_components.p, {
          children: "Svůj nastavený limit můžete snížit či zvýšit opětovným zadáním limitu na detailu dražené položky."
        }), _jsx(_components.p, {
          children: "Při snížení limitního příhozu nesmí být zadaný limit pod aktuální cenou díla a minimálního příhozu."
        }), _jsx(_components.p, {
          children: "Při zvýšení limitního příhozu stačí zadat pouze novou, vyšší cenu."
        }), _jsx(_components.p, {
          children: "V případě, že v aukci vedete a nastavíte nový limit, systém Váš limit uloží, ale Vás samotné nepřehodí."
        })]
      }), "\n", _jsxs(Q, {
        title: "Kde se mohu dozvědět více informací o konkrétní položce v aktuální aukci?",
        children: [_jsx(_components.p, {
          children: "Všechny základní informace o aukční položce jako jsou její rozměry, datace, signatura, technika, stav a popřípadě další dodatečný popis, naleznete na stránce detailu daného díla."
        }), _jsxs(_components.p, {
          children: ["Pokud byste však měli dotazy nad rámec zveřejněných informací, kontaktujte nás prostřednictvím kontaktního formuláře na stránce ", _jsx(_components.a, {
            href: "/contact",
            children: "Kontakt"
          }), "."]
        })]
      }), "\n", _jsxs(Q, {
        title: "Mohu si díla v aktuální aukci prohlédnout osobně?",
        children: [_jsx(_components.p, {
          children: "Ano. Díla v aktuální aukci si můžete přijít osobně prohlédnout během předaukční výstavy, která bude vždy předem oznámena na webovém portálu AIG spolu s e-mailovou pozvánkou zaslanou všem registrovaným uživatelům."
        }), _jsx(_components.p, {
          children: "V případě, že se nemůžete předaukční výstavy zúčastnit, můžete využít možnosti prohlédnou si aktuálně dražená díla pomocí virtuální prohlídky."
        })]
      }), "\n", _jsx(Q, {
        title: "Jak postupovat, když jsem vyhrál aukci?",
        children: _jsx(_components.p, {
          children: "V případě Vaší výhry v aukci, o které budete informováni také prostřednictvím e-mailu, Vám systém zpřístupní možnost vytvořit objednávku. Ve svém uživatelském profilu přejděte do sekce „vydražené položky“a zde si vyberte Vámi vydražená díla a vytvořte objednávku. V procesu objednávky si zvolíte způsob doručení a metodu placení."
        })
      }), "\n", _jsx(Q, {
        title: "Mohu zrušit svůj příhoz?",
        children: _jsx(_components.p, {
          children: "Nemůžete. Všechny příhozy jsou závazné a jejich stornování je vyloučeno."
        })
      }), "\n", _jsx(Q, {
        title: "Jak si zobrazím položky, na které aktuálně přihazuji?",
        children: _jsx(_components.p, {
          children: "Všechny aukční položky v aktuální aukci, u kterých přihazujete, si jednoduše zobrazíte přes uživatelský účet „probíhající aukce“."
        })
      }), "\n", _jsxs(Q, {
        title: "Je možné dostat upozornění na vybrané položky nebo na konkrétní umělce?",
        children: [_jsx(_components.h3, {
          children: "Sledování díla"
        }), _jsx(_components.p, {
          children: "V případě, že chcete sledovat cenový vývoj položky v aktuální aukci, klikněte na tlačítko „hlídat položku“ na stránce detailu draženého díla. Při změně ceny na konci dne dostanete e-mail o vývoji ceny Vámi sledovaného díla a počtu dražitelů."
        }), _jsx(_components.p, {
          children: "Rovněž budete upozorněni na blížící se konec dražby sledované položky."
        }), _jsx(_components.h3, {
          children: "Sledování umělce"
        }), _jsx(_components.p, {
          children: "Pokud chcete sledovat konkrétního umělce a dostávat tak e-mailové notifikace o přidání jeho díla do aukčního či komisního prodeje, na stránce detailu umělce klikněte na tlačítko „sledovat umělce“."
        }), _jsx(_components.p, {
          children: "Správu všech sledovaných umělců a položek najdete v uživatelském účtu pod záložkou „sledované položky“."
        })]
      }), "\n", _jsxs(Q, {
        title: "Co když dílo vydražím a nakonec ho nebudu chtít?",
        children: [_jsx(_components.p, {
          children: "Vzhledem k tomu, že všechny uživatelem provedené příhozy jsou závazné a nelze je zrušit, je kupující povinen vydražené dílo uhradit a převzít."
        }), _jsx(_components.p, {
          children: "V případě nedodržení obchodních podmínek a neuhrazení částky vydraženého díla v plné výši včetně aukční přirážky, je provozovatel aukce oprávněn odstoupit od kupní smlouvy, vydražené dílo opětovně zařadit do následující aukce a požadovat od kupujícího náhradu vzniklé škody a výši 30% z vydražené ceny díla."
        })]
      }), "\n", _jsx(_components.h1, {
        children: "Doprava / platba / poplatky"
      }), "\n", _jsx(Q, {
        title: "Musím zaplatit vydražené / zakoupené dílo v EUR?",
        children: _jsx(_components.p, {
          children: "Nemusíte. V základní měně EUR na portále AIG pouze probíhají příhozy. V případě výhry v aukci má uživatele možnost v průběhu vytvoření objednávky zvolit měnu, ve které bude faktura vystavena."
        })
      }), "\n", _jsx(Q, {
        title: "Jaké jsou aukční přirážky a poplatky spojené s dražbou?",
        children: _jsx(_components.p, {
          children: "Ke každé konečné ceně vydražené položky je připočítávána aukční přirážka na stranu kupujícího ve výši 20%, ve které jsou zahrnuty všechny provize a poplatky spojené s dražbou díla."
        })
      }), "\n", _jsxs(Q, {
        title: "Jak mohu za vydražené / zakoupené dílo zaplatit?",
        children: [_jsx(_components.p, {
          children: "Při vytváření objednávky Vámi vydraženého či zakoupeného díla máte možnost zvolit preferovanou metodu platby."
        }), _jsxs(_components.ul, {
          children: ["\n", _jsx(_components.li, {
            children: "Hotovostní platba při osobním převzetí (podle zákona pouze v případě ceny díla do 270.000,- Kč, cca 10.000 EUR)"
          }), "\n", _jsx(_components.li, {
            children: "Převodem na účet"
          }), "\n", _jsx(_components.li, {
            children: "Platba v jedné z podporovaných kryptoměn pomocí platební brány Coinbase"
          }), "\n"]
        })]
      }), "\n", _jsxs(Q, {
        title: "Jak je to s přepravou / vyzvednutím díla?",
        children: [_jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Osobní vyzvednutí na pobočce v České republice"
          }), " – jakmile bude Vaše vydražené dílo připraveno k převzetí na dané pobočce, obdržíte e-mailem výzvu k jeho převzetí. Doporučujeme Vám se s námi spojit a domluvit si konkrétní termín převzetí vydraženého díla pro rychlejší odbavení."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Osobní vyzvednutí na pobočce mimo Českou republiku"
          }), " – jakmile bude Vaše vydražené dílo připraveno k převzetí na dané pobočce, obdržíte e-mailem výzvu k jeho převzetí. Za doručení díla na vybranou pobočku mimo Českou republiku se platí paušální poplatek ve výši 100 EUR / dílo."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Doručení na adresu v rámci České republiky"
          }), " – v rámci České republiky Vám dílo zdarma doručíme na adresu, kterou jste uvedli při zpracování objednávky. Po připsání Vaší platby na účet, Vás budeme kontaktovat a domluvíme s Vámi termín doručení vydraženého díla."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Doručení díla na adresu mimo Českou republiku"
          }), " – v případě doručení díla na adresu mimo ČR využíváme externí přepravní službu za paušální poplatek 100 EUR / dílo. Po připsání platby na náš účet, připravíme dílo k transportu a budete informováni přepravcem o termínu jeho doručení."]
        })]
      }), "\n", _jsx(_components.h1, {
        children: "Pro prodávající"
      }), "\n", _jsxs(Q, {
        title: "Jak nabídnout dílo do aukce, komisního prodeje nebo pro výkup?",
        children: [_jsx(_components.p, {
          children: "V případě, že chcete nabídnout Vámi vlastněné dílo do naší internetové aukce, využijte „nabídkový formulář“ na webu AIG. Na hlavní stránce najdete odkaz"
        }), _jsx(_components.p, {
          children: "„nabídnout dílo“. Zde vyplňte všechny požadované informace o díle a přiložte jeho fotografie."
        }), _jsx(_components.p, {
          children: "Do poznámky nám sdělte, zda chcete dílo nabídnout do aukce, komisního prodeje nebo nám chcete dílo prodat a potvrďte odeslání formuláře."
        })]
      }), "\n", _jsx(Q, {
        title: "Jaký je poplatek za přijetí nabízeného díla do aukce?",
        children: _jsx(_components.p, {
          children: "Aukční provize jenž platí prodávající není fixní. Vždy záleží na předběžné domluvě nebo na dosažené ceně draženého díla. Aukční provize vždy však činí maximálně 10% z prodejní ceny, což je i přesto nejnižší aukční provize pro prodávajícího na trhu."
        })
      }), "\n", _jsxs(Q, {
        title: "Co dělat, když se dílo v aukci nevydraží?",
        children: [_jsx(_components.p, {
          children: "V případě, že se Vámi nabízené dílo v aukci nevydraží, dostanete možnost jej umístit do poaukčního prodeje na dobu 30, 60 nebo 90 dnů. Zde se již dílo nebude dražit, ale bude nabídnuto za pevně stanovenou cenu, na které se s námi dohodnete."
        }), _jsx(_components.p, {
          children: "Rovněž budou mít všichni uživatelé možnost nabídnout cenu, za kterou jsou ochotni dílo zakoupit. O všech těchto nabídkách Vás budeme v průběhu vystavení díla informovat."
        })]
      }), "\n", _jsxs(Q, {
        title: "Chci prodat dílo, ale nechci jej umístit do aukce.",
        children: [_jsx(_components.p, {
          children: "V případě, že chcete Vaše dílo prodat, ale nechcete jej umístit do aukce s nejistou výslednou cenou, můžete Vámi nabízené dílo nabídnout k tzv. komisnímu prodeji. Zde bude po sjednanou dobu dílo vystaveno za pevnou kupní cenu. Rovněž všichni uživatelé budou mít možnost nabídnout cenu, za kterou jsou ochotni dílo zakoupit. O všech těchto nabídkách Vás budeme v průběhu vystavení díla informovat."
        }), _jsx(_components.p, {
          children: "V případě, že nechcete čekat ani na následný prodej díla, můžete nám dílo nabídnout k okamžitému výkupu."
        }), _jsx(_components.p, {
          children: "V případě komisního prodeje platí stejné sazby jako pro dražbu v online aukci. Prodávající platí sjednaný % poplatek z ceny díla, ne však vyšší, než 10%."
        })]
      }), "\n", _jsx(Q, {
        title: "Kdy dostanu peníze za vydražené dílo, které jsem nabídnul do aukce?",
        children: _jsx(_components.p, {
          children: "Vaše peníze z prodeje díla v internetové aukci obdržíte od 15 do 30 dnů od ukončení aukce (v závislosti na rychlosti platby kupujícího a odbavení platebních příkazů z naší strany)."
        })
      })]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
